//DON'T REMOVE THIS LINE
import React from "react";
import { observer } from "mobx-react";

import {
  pixelSizeByZoom,
  svgTextCondensed,
} from "@dvsproj/ipat-core/planUtils";
import { toFixedPrecision, remToPx } from "../../utils/uiUtils";

import { useIntl } from "react-intl";

import Draggable from "../Draggable";
import { WaterflowSVG, WaterdropSVG } from "../pipes/PipePointIcons";
import useStores from "../../hooks/useStores";

export const RzwsSVG = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      className="sprinkler-border"
      d="M12 2 1 20h22z"
      fill="#fff"
      stroke="#3e4346"
      strokeWidth="1"
    />
    <path d="M12 6l7 12H5z" fill="#529f40" />
  </svg>
);

export const RaisedBedSVG = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      className="sprinkler-border"
      d="M3 3h18v18H3z"
      fill="#fff"
      stroke="#3e4346"
      strokeWidth="1"
    />
    <path d="M5 5h14v14H5z" fill="#a75712" />
  </svg>
);

const NotCrossSVG = () => {
  return (
    <g transform="translate(-12 -12)">
      <path
        d="M 23.871 10.333 l 0.014 -0.015 c -0.016 -0.118 -0.049 -0.23 -0.069 -0.347 c -0.042 -0.244 -0.09 -0.485 -0.146 -0.724 c -0.048 -0.209 -0.1 -0.415 -0.159 -0.62 s -0.127 -0.4 -0.2 -0.594 c -0.057 -0.163 -0.1 -0.332 -0.162 -0.491 l -0.013 0.013 a 12.075 12.075 0 0 0 -0.687 -1.437 l 0.012 -0.012 c -0.122 -0.216 -0.264 -0.418 -0.4 -0.625 c -0.052 -0.081 -0.1 -0.165 -0.156 -0.244 c -0.148 -0.215 -0.307 -0.421 -0.468 -0.626 c -0.092 -0.118 -0.183 -0.237 -0.28 -0.351 c -0.055 -0.066 -0.1 -0.137 -0.159 -0.2 l -0.012 0.012 a 12.1 12.1 0 0 0 -1.062 -1.062 l 0.012 -0.012 c -0.064 -0.056 -0.136 -0.1 -0.2 -0.159 c -0.114 -0.1 -0.233 -0.188 -0.351 -0.28 c -0.2 -0.161 -0.41 -0.32 -0.626 -0.468 c -0.08 -0.055 -0.163 -0.1 -0.244 -0.157 c -0.207 -0.134 -0.409 -0.276 -0.625 -0.4 l -0.012 0.012 a 12.073 12.073 0 0 0 -1.437 -0.687 l 0.013 -0.013 c -0.159 -0.063 -0.328 -0.1 -0.491 -0.162 c -0.2 -0.069 -0.393 -0.137 -0.594 -0.2 s -0.412 -0.111 -0.62 -0.159 c -0.239 -0.056 -0.48 -0.1 -0.724 -0.146 c -0.117 -0.02 -0.229 -0.053 -0.347 -0.069 l -0.015 0.014 a 11.916 11.916 0 0 0 -13.538 13.538 l -0.014 0.015 c 0.016 0.118 0.049 0.23 0.069 0.347 c 0.042 0.244 0.09 0.485 0.146 0.724 c 0.048 0.208 0.1 0.415 0.159 0.619 s 0.127 0.4 0.2 0.6 c 0.056 0.162 0.1 0.331 0.161 0.49 l 0.013 -0.013 a 12.075 12.075 0 0 0 0.687 1.437 l -0.012 0.012 c 0.122 0.216 0.264 0.418 0.4 0.625 c 0.052 0.081 0.1 0.164 0.156 0.244 c 0.148 0.215 0.306 0.421 0.467 0.626 c 0.093 0.118 0.184 0.237 0.281 0.352 c 0.055 0.065 0.1 0.136 0.159 0.2 l 0.012 -0.012 a 12.1 12.1 0 0 0 1.062 1.062 l -0.012 0.012 c 0.064 0.056 0.135 0.1 0.2 0.159 c 0.115 0.1 0.234 0.188 0.352 0.28 c 0.2 0.162 0.411 0.321 0.626 0.469 c 0.079 0.054 0.163 0.1 0.243 0.155 c 0.207 0.135 0.41 0.277 0.626 0.4 l 0.012 -0.012 a 12.073 12.073 0 0 0 1.437 0.687 l -0.013 0.013 c 0.159 0.063 0.328 0.1 0.49 0.161 c 0.2 0.069 0.394 0.138 0.6 0.2 s 0.41 0.111 0.619 0.159 c 0.239 0.056 0.481 0.1 0.725 0.146 c 0.117 0.02 0.229 0.053 0.346 0.069 l 0.015 -0.014 a 11.916 11.916 0 0 0 13.538 -13.538 z m -22.371 1.667 a 10.512 10.512 0 0 1 10.5 -10.5 c 0.095 0 0.187 0.012 0.282 0.014 l -10.768 10.768 c -0.002 -0.094 -0.014 -0.187 -0.014 -0.282 z m 0.53 3.275 l 13.245 -13.245 a 10.545 10.545 0 0 1 1.5 0.628 l -14.113 14.113 a 10.542 10.542 0 0 1 -0.632 -1.496 z m 2.043 3.59 l 14.792 -14.792 a 10.643 10.643 0 0 1 1.062 1.062 l -14.792 14.792 a 10.643 10.643 0 0 1 -1.062 -1.062 z m 3.156 2.477 l 14.113 -14.113 a 10.542 10.542 0 0 1 0.628 1.5 l -13.245 13.241 a 10.545 10.545 0 0 1 -1.496 -0.628 z m 4.771 1.158 c -0.095 0 -0.188 -0.012 -0.282 -0.014 l 10.768 -10.768 c 0 0.094 0.014 0.187 0.014 0.282 a 10.512 10.512 0 0 1 -10.5 10.5 z"
        fill="#ff7600"
        opacity=".75"
      />
    </g>
  );
};

function Text({
  title,
  waterflow,
  waterpressure,
  zoomDelta,
  fromElementDrawing = false,
  waterflowInfo = true,
  hasWaterpressureWarn = false,
  waterpressureInfo = false,
}) {
  const { formatMessage, formatNumber } = useIntl();

  const waterflowPrecision = formatNumber(
    toFixedPrecision(waterflow / 1000, 2)
  );

  return (
    <g>
      {title && (
        <>
          <text x="0" y="0" {...svgTextCondensed}>
            <tspan
              x="0"
              y="0"
              className={`sprinkler-info-title`}
              style={{ fontWeight: 700 }}
            >
              {!fromElementDrawing && formatMessage({ id: title })}
            </tspan>
            {waterflowInfo && waterflow && (
              <tspan x="1em" dy="1.2em">
                {waterflowPrecision} m
                <tspan dy={-pixelSizeByZoom(5, zoomDelta)} fontSize="75%">
                  3
                </tspan>
                <tspan dy={pixelSizeByZoom(5, zoomDelta)}>/h</tspan>
              </tspan>
            )}
            {!fromElementDrawing &&
              waterpressureInfo &&
              waterpressure != null && (
                <tspan
                  x="1em"
                  dy="1.2em"
                  fill={hasWaterpressureWarn ? "#ff7600" : "3e4346"}
                  style={{ fontWeight: 500 }}
                >
                  {waterpressure} bar
                </tspan>
              )}
          </text>
          {waterflowInfo && waterflow && (
            <g
              transform={`translate(0, ${pixelSizeByZoom(
                5,
                zoomDelta
              )}) scale(${pixelSizeByZoom(1, zoomDelta)})`}
            >
              <WaterflowSVG />
            </g>
          )}
          {!fromElementDrawing && waterpressureInfo && hasWaterpressureWarn && (
            <g
              transform={`translate(0, ${pixelSizeByZoom(
                23,
                zoomDelta
              )}) scale(${pixelSizeByZoom(1, zoomDelta)})`}
            >
              <WaterdropSVG />
            </g>
          )}
        </>
      )}
    </g>
  );
}

function SpecificSprinklerElementBody({
  type,
  title,
  zoomDelta,
  waterflow,
  waterpressure,
  hasWaterpressureWarn = false,
  fromElementDrawing = false,
  textsVisibility = {},
  titleHidden = false,
  hidden = false,
  hasInvalid = false,
  inNonCrossedArea = false,
}) {
  var Element;
  var r = 12;
  switch (type) {
    case "rzws":
      Element = <RzwsSVG />;
      break;
    case "raised-bed":
      Element = <RaisedBedSVG />;
      break;
    default:
      break;
  }
  const textStyle = {
    fontSize: pixelSizeByZoom(remToPx(0.875), zoomDelta),
    letterSpacing: pixelSizeByZoom(0.6, zoomDelta),
  };

  return (
    <g className="sprinkler" style={textStyle}>
      {textsVisibility.sprinklerElements && (
        <g
          className={hidden ? "element-hidden" : ""}
          transform={`translate(${-pixelSizeByZoom(
            r,
            zoomDelta
          )},${-pixelSizeByZoom(r, zoomDelta)}) scale(${pixelSizeByZoom(
            1,
            zoomDelta
          )})`}
        >
          {Element}
        </g>
      )}
      {textsVisibility.sprinklersTexts && !titleHidden && (
        <g
          className="sprinkler-info"
          transform={`translate(0, ${pixelSizeByZoom(20, zoomDelta)})`}
        >
          <Text
            title={title}
            waterflow={waterflow}
            zoomDelta={zoomDelta}
            fromElementDrawing={fromElementDrawing}
            waterflowInfo={textsVisibility.sprinklersWaterflowText}
            waterpressure={waterpressure}
            hasWaterpressureWarn={hasWaterpressureWarn}
            waterpressureInfo={textsVisibility.sprinklersWaterpressureText}
          />
        </g>
      )}
      {hasInvalid || inNonCrossedArea ? (
        <g transform={`scale(${pixelSizeByZoom(1, zoomDelta)})`}>
          <NotCrossSVG />
        </g>
      ) : null}
    </g>
  );
}

function SpecificSprinklerElement({
  type,
  id,
  x,
  y,
  drag,
  disabled,
  zoomDelta,
  isSelected,
  isHovered,
  hasInvalid,
  elementIsChanged,
  inNonCrossedArea,
  hidden,
  title,
  scale,
  useDefaultStyles,
  waterflow,
  waterpressureInBar,
  hasWaterpressureWarn,
  precision,
  titleHidden,
  textsVisibility,
  fromElementDrawing,
  setSelectedElement,
  onChange,
  remove,
}) {
  return (
    <Draggable
      id={id}
      x={x}
      y={y}
      move={drag}
      onChange={onChange}
      onAfterMove={() => {
        onChange();
      }}
      draggable={!disabled}
      cloneable={!disabled}
      dragProps={id}
      movePhase="drag"
      onClick={() => {
        setSelectedElement(id);
      }}
      onDoubleClick={() => {
        remove(id, false);
      }}
    >
      <g
        className={`element sprinkler ${
          isHovered || isSelected ? "active" : ""
        } ${hasInvalid ? "invalid" : ""}`}
        onMouseEnter={(e) => {
          if (!elementIsChanged) {
            const sprinkler = e.target.closest(".sprinkler");
            if (sprinkler) {
              sprinkler.classList.add("hovered");
            }
          }
        }}
        onMouseLeave={(e) => {
          if (!elementIsChanged) {
            const sprinkler = e.target.closest(".sprinkler");
            if (sprinkler) {
              sprinkler.classList.remove("hovered");
            }
          }
        }}
      >
        <SpecificSprinklerElementBody
          type={type}
          zoomDelta={zoomDelta}
          isSelected={isSelected}
          hasInvalid={hasInvalid}
          hidden={hidden}
          inNonCrossedArea={inNonCrossedArea}
          scale={scale}
          useDefaultStyles={useDefaultStyles}
          title={title}
          waterflow={waterflow}
          waterpressure={waterpressureInBar}
          hasWaterpressureWarn={hasWaterpressureWarn}
          precision={precision}
          titleHidden={titleHidden}
          textsVisibility={textsVisibility}
          fromElementDrawing={fromElementDrawing}
        />
      </g>
    </Draggable>
  );
}

let SpecificSprinklerElementWithState = ({ element, ...props }) => {
  const { uiState } = useStores();
  return (
    <SpecificSprinklerElement
      type={element.type}
      id={element.id}
      x={element.x}
      y={element.y}
      title={element.title}
      titleHidden={element.titleHidden}
      hidden={element.hidden}
      waterflow={element.waterflow}
      waterpressureInBar={element.waterpressureInBar}
      hasWaterpressureWarn={element.hasWaterpressureWarn}
      hasInvalid={element.hasInvalid}
      inNonCrossedArea={element.inNonCrossedArea}
      isHovered={element.id === uiState.hoveredElementId}
      isSelected={element.id === uiState.selectedElementId}
      drag={element.drag}
      disabled={element.disabled || !uiState.planIsEditable}
      zoomDelta={uiState.zoomState.zoomDelta}
      setSelectedElement={
        uiState.selectedTool === "select"
          ? uiState.setSelectedElement
          : () => {}
      }
      setHoveredElementId={
        uiState.selectedTool === "select"
          ? uiState.setHoveredElementId
          : () => {}
      }
      {...props}
    />
  );
};

SpecificSprinklerElementWithState = observer(SpecificSprinklerElementWithState);
export default SpecificSprinklerElementWithState;
